import { Spin } from 'antd';
import { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import DashboardLayout from 'src/components/Layouts/DashboardLayout';
import PageLoader from 'src/components/Loader/PageLoader';
import AuthProvider from 'src/contexts/AuthContext';
import { LocationState, UserRole } from 'src/features/common-types';
import useAuth from 'src/hooks/useAuth';

const DashboardRoutes = () => {
  const { user, isProfileLoading } = useAuth();
  const location = useLocation();
  const isAuthenticated = !!user;
  const from = (location.state as LocationState)?.from;

  // useEffect(() => {
  //   void (async () => {
  //     if (!authError) return;
  //     await message.open({
  //       type: 'error',
  //       content: authError,
  //       duration: 10,
  //     });
  //   })();
  // }, [authError]);

  return (
    <DashboardLayout>
      <Spin
        spinning={isProfileLoading}
        wrapperClassName="full-width"
        style={{ minHeight: '80vh' }}
        size="small"
      >
        <Suspense fallback={<PageLoader />}>
          {isAuthenticated ? (
            <Outlet />
          ) : (
            <Navigate
              to={from?.pathname || '/dashboard/vehiclehistory'}
              state={{ from: location }}
              replace
            />
          )}
        </Suspense>
      </Spin>
    </DashboardLayout>
  );
};

const Page = () => (
  <AuthProvider>
    <DashboardRoutes />
  </AuthProvider>
);

export default Page;
